if (!customElements.get('collection-masks-slider')) {
  customElements.define(
    'collection-masks-slider',
    class CollectionMasksSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('button[name="previous"]');
        this.next = this.querySelector('button[name="next"]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.prev.addEventListener('click', () => this.scrollByItems(-1));
        this.next.addEventListener('click', () => this.scrollByItems(1));
        this.track.addEventListener('scroll', this.update, { passive: true });

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();

        if (window.Shopify && Shopify.designMode) {
          this.onBlockSelect = (event) => {
            if (!this.track.contains(event.target)) return;
            this.track.scrollTo({ left: event.target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get step() {
        const item = this.track.firstElementChild;
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      scrollByItems(direction) {
        this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-static', maxScroll <= 2);
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }
  );
}
